import Modal from 'antd/lib/modal/Modal';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {generateRetirementPlan} from '../../../actions/plan';
import {FixedHeightContent, ScrollableContent} from '../../../constants/styles';
import {AppState, AppUser, Maybe, PlanActions, PlanInput} from '../../../types';
import BasicPlanForm from './BasicPlanForm';


type Props = {};


export default function BasicPlanModal(_props: Props) {
  const basicPlanModalOpen = useSelector<AppState, boolean>(state => state.plans.basicPlanModalOpen);
  const dispatch = useDispatch();
  const closeModal = () => dispatch({type: PlanActions.SET_BASIC_PLAN_MODAL, payload: {modal_open: false}});
  const generatePlan = (data: PlanInput, user: Maybe<AppUser>) => dispatch(generateRetirementPlan(data, user));
  const user = useSelector<AppState, Maybe<AppUser>>(state => state.user.user);
  const plan_type = useSelector<AppState, string>(state => state.plans.basicPlanModalPlanType);
  return (
    <FixedHeightContent
      maxHeight="60vh"
    >
      <Modal
        title={`Generar plan "${plan_type}"`}
        visible={basicPlanModalOpen}
        footer={null}
        onCancel={() => { closeModal(); }}
        >
        <ScrollableContent
          maxHeight="70vh"
        >
          <BasicPlanForm
            plan_type={plan_type}
            onSubmit={(values) => {
              closeModal();
              generatePlan(values, user);
            }}
          />
        </ScrollableContent>
        
      </Modal>
    </FixedHeightContent>
  );
}